export default "__VITE_ASSET__5b2e0322__"